import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoModule } from '@jsverse/transloco';
import { FormErrorsComponent } from '../form-errors/form-errors.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LimitHintComponent } from '../limit-hint/limit-hint.component';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

@Component({
  selector: 'boels-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    FormErrorsComponent,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
    FontAwesomeModule,
    NgbTooltipModule,
    LimitHintComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic', appearance: 'outline' },
    },
  ],
})
export class TextInputComponent implements ControlValueAccessor {
  @Input() name = '';
  @Input() label? = '';
  @Input() type: 'text' | 'email' | 'tel' = 'text';
  @Input() placeholder = '';
  @Input() value = '';
  @Input() required = false;
  @Input() formControl: FormControl | AbstractControl;
  @Input() faIcon: IconDefinition;
  @Input() tooltipMessage = '';
  @Input() additionalLabel = '';
  @Input() hideErrors = false;
  @Input() maxlength: number;
  @Input() withMargin = true;
  @Input() enterKeyHint: string;
  @Input() onKeypress?: (event: KeyboardEvent) => boolean = () => true;
  /** Could be transformed to string[] if there are other exception types. */
  @Input() customError: string;

  touched = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched: any = () => {};

  change(value: string) {
    this.markAsTouched();
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  private markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
